import { ModalTitle } from "@component/common/ModalText";
import ModalBox from "@component/common/ModalBox";
import ModalComponent from "@component/common/ModalComponent";
import StandardInput from "@component/common/StandardInput";
import BannerImageInput, { BannerImage } from "./BannerImageInput";
import RowBox from "@component/common/RowBox";
import ButtonText from "@component/common/ButtonText";
import { BannerEntity } from "@entity/banner.entity";
import { useDictInput } from "@hook/useDictInput";
import { useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import bannerRepository from "@api/banner/banner.repository";
import { NoticePostOption } from "@interface/banner";

interface BannerModalProps {
  title: string;
  data?: BannerEntity | null;
  onCanceled: () => void;
  onSaved: (
    order: number,
    title: string,
    noticePostId: string | null,
    file?: any
  ) => void;
}

/** 공지사항을 연결하지 않은 상태를 나타내는 값 */
const NO_NOTICE = "";

export default function BannerModal({
  title,
  data,
  onCanceled,
  onSaved,
}: BannerModalProps) {
  const [banner, setBanner, onBannerChange] = useDictInput<
    BannerEntity | null | undefined
  >(data);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const [noticePosts, setNoticePosts] = useState<NoticePostOption[]>([]);
  const [noticePostId, setNoticePostId] = useState<string>(
    data?.noticePostId ?? NO_NOTICE
  );

  useEffect(() => {
    bannerRepository
      .getNoticePosts()
      .then(setNoticePosts)
      .catch((error) => console.error("공지사항 목록 조회 실패:", error));
  }, []);
  return (
    <>
      <ModalBox width={480}>
        <ModalTitle>{title}</ModalTitle>
        <ModalComponent
          marginBottom={32}
          description="배너 순번"
          component={
            <StandardInput
              name="order"
              value={banner ? banner.order : ""}
              onChange={onBannerChange}
            />
          }
        />
        <ModalComponent
          marginBottom={32}
          description="배너 관리용 제목"
          component={
            <StandardInput
              name="title"
              value={banner ? banner.title : ""}
              onChange={onBannerChange}
            />
          }
        />
        <ModalComponent
          marginBottom={32}
          description="연결할 공지사항 (선택)"
          component={
            <FormControl fullWidth>
              <Select
                sx={{ fontSize: "12px", height: "40px" }}
                displayEmpty
                value={noticePostId}
                onChange={(e) => setNoticePostId(e.target.value)}
              >
                <MenuItem sx={{ fontSize: "12px" }} value={NO_NOTICE}>
                  연결 안 함
                </MenuItem>
                {noticePosts.map((post) => (
                  <MenuItem
                    key={post.id}
                    sx={{ fontSize: "12px" }}
                    value={post.id}
                  >
                    {post.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
        />
        <ModalComponent
          marginBottom={32}
          description="이미지(335*170)"
          component={
            banner && banner.imageUrl ? (
              <BannerImage alt="배너 이미지" src={banner.imageUrl} />
            ) : (
              <BannerImageInput onImageChange={handleFileChange} />
            )
          }
        />
        <RowBox height="auto" marginTop={0}>
          <ButtonText
            onClick={onCanceled}
            color="#8D8D8D"
            backgroundColor="#F5F5F5"
          >
            취소
          </ButtonText>
          <ButtonText
            onClick={() => {
              if (!banner) return;
              // 등록 시에는 이미지가 필수지만, 수정 시에는 기존 이미지를 그대로 두고
              // 순번/제목/공지 연결만 바꿀 수 있어야 한다
              const needsImage = !banner.imageUrl;
              if (needsImage && !selectedFile) return;

              onSaved(
                banner.order,
                banner.title,
                noticePostId === NO_NOTICE ? null : noticePostId,
                selectedFile ?? undefined
              );
            }}
            color="#FFFFFF"
            backgroundColor="#84C64A"
          >
            저장
          </ButtonText>
        </RowBox>
      </ModalBox>
    </>
  );
}
